import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IAutomaticReloadParametersFormMeta {
    automaticReload: FormInputMeta;
    periodicity: FormInputMeta;
    rechargeableAmount: FormInputMeta;
    paymentMode: FormInputMeta;
    accountNumber: FormInputMeta;
    reload: FormInputMeta;


}

const automaticReloadParametersFormMeta = {} as IAutomaticReloadParametersFormMeta;

automaticReloadParametersFormMeta.automaticReload = {
    name: "automaticReload",
    type: "checkbox",
    label: "Recharge Automatique",
    placeholder: "",
    validation: yup.boolean()
};

automaticReloadParametersFormMeta.periodicity = {
    name: "periodicity",
    type: "select",
    label: "Périodicité",
    placeholder: "",
    validation: yup.string()
};

automaticReloadParametersFormMeta.rechargeableAmount = {
    name: "rechargeableAmount",
    type: "number",
    label: "Montant Rechargeable",
    placeholder: "",
    validation: yup.number()
};

automaticReloadParametersFormMeta.paymentMode = {
    name: "paymentMode",
    type: "select",
    label: "Mode Paiement",
    placeholder: "",
    validation: yup.string()
};

automaticReloadParametersFormMeta.accountNumber = {
    name: "accountNumber",
    type: "text",
    label: "Numéro Compte",
    placeholder: "",
    validation: yup.string()
};

automaticReloadParametersFormMeta.reload = {
    name: "reload",
    type: "select",
    label: "Recharger",
    placeholder: "",
    validation: yup.string()
};


export default automaticReloadParametersFormMeta;